<template>
  <div class="home">
    <error-handler :error="error"/>
      <div class="row">
        <div class="col-md-12">
          <h1>Bem vindo...</h1>
        </div>
      </div>
      <div class="row mt-4"> 
        <div class="col-md-6 mb-4">
          <div class="card">
            <div class="card-body">
              <h5 class="text-primary"><i class="fas fa-lg fa-birthday-cake mr-2"></i>Aniversariantes do dia</h5>
              <template v-for="person in data.birthdays.data">
                <div class="row"  :key="'person'+ person.id">
                  <div class="col-12 mt-3">
                    {{ person.name }}
                    <a class="btn btn-link text-success" v-if="person.phone_wa != null" :href="getWhatsAppLink(person)" target="_blank"><i class="fab fa-lg fa-whatsapp"></i></a>
                  </div>
                </div>
              </template> 
            </div>
          </div>
        </div>

        <div class="col-md-6 mb-4">
          <div class="card">
            <div class="card-body">
              <h5 class="text-primary"><i class="fas fa-gift"></i> Novidades</h5>
              <div class="row">
                
                <div class="col-md-12 mt-3">
                  <div class="mb-2">
                    <b class="text-primary">
                      <i class="fas fa-birthday-cake"></i> Não esqueça do seu cliente!
                    </b>
                    <small class="text-muted">24/11</small>
                  </div>
                  Aqui ao lado, será exibido diariamente os aniversariantes do dia, caso o número de whatsapp esteja cadastrado, é só clicar no botão 
                  <i class="fab fa-whatsapp"></i> , que você será redirecionado para o aplicativo do WhatsApp (no celular) ou para o WhatsApp Desktop ou Web caso esteja 
                  utilizando o sistema no computador. Que tal um desconto especial no dia do seu cliente...
                </div>


                <div class="col-md-12 mt-5">
                  <div class="mb-2">
                    <b class="text-primary">
                      <i class="far fa-smile-beam"></i> Olá...
                    </b>
                    <small class="text-muted">24/11</small>
                  </div>
                  Olá, esse é o Apex Erp, o nosso objetivo é sempre estar ao seu lado, para melhorar a gestão do seu 
                  negócio com inovação e tecnologia, poupando o seu tempo e de toda sua equipe. Nossa plataforma está em constante aprimoramento, para que você
                  não perca nada, todos novos recursos do sistema serão informados aqui. Obrigado por utilizar os nossos serviços!
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  
  name: 'home',
  
  components: { },

  data : function () {
      
    return {
      isLoading : false,

      data : {
        birthdays : {
          data : {}
        }
      },

      error : null
    }
  },

  created() {
    
    this.$store.commit('pageHasLoaded')
    
    axios.post('api/home/index')
      .then(response => {
        
        this.data = response.data

      })
      .catch(error => {

        console.log(error)
        this.error = error

      })
  },

  methods : {
    getWhatsAppLink(person) {
      let name = person.name.replace(/ .*/, '');
      let link = 'https://api.whatsapp.com/send?phone=+55' + person.phone_wa 
      let msg  = '&text=Olá ' + name + ', parabéns pelo seu aniversário!' 

      return link + msg
    }
  }

  
}
</script>
